import React from 'react';
import { IconBaseProps } from 'react-icons';
import { FaEdit } from 'react-icons/fa';

const Edit: React.FC<IconBaseProps> = (props) => <FaEdit {...props} />;

export default Edit;
